import { render, staticRenderFns } from "./breeder-bio-details-page.vue?vue&type=template&id=50c1100c&scoped=true&lang=pug"
import script from "./breeder-bio-details-page.js?vue&type=script&lang=js&external"
export * from "./breeder-bio-details-page.js?vue&type=script&lang=js&external"
import style0 from "./breeder-bio-details-page.vue?vue&type=style&index=0&id=50c1100c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1100c",
  null
  
)

export default component.exports